<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<i18n src="@/locales/modules/CustomerTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="setDialogHide => handleCloseDialog(setDialogHide, isFormDirty)"
		class="custom-dialog"
		:title="$t(Object.entries(this.data).length === 0 ? 'AddNewCustomer' : 'UpdateCustomer')"
		:visible.sync="isSidebarActiveLocal"
	>
		<PerfectScrollbar ref="vueScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6">
				<!-- Group Customer -->
				<vs-input
					v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'group', 'update'))"
					:label="`${$t('GroupCustomer')}:`"
					:placeholder="`${$t('Actions.Input')} ${$t('GroupCustomer')}`"
					v-model="group"
					class="mb-5 w-full"
					name="group"
				/>
				<!-- CODE -->
				<vs-input :disabled="dataId" :label="`${$t('Code')}:`" :placeholder="`${$t('Actions.Input')} ${$t('Code')}`" v-model="dataCode" class="mb-5 w-full" name="code" />

				<!-- NAME -->
				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'name', 'update'))">
					<label for class="vs-input--label"> {{ $t("FullName") }}<span class="text-danger">*</span>: </label>
					<vs-input :data-vv-as="$t('FullName')" :placeholder="`${$t('Actions.Input')} ${$t('FullName')}`" v-model="dataName" class="w-full" name="name" v-validate="'required'" />
					<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first("name") }}</span>
				</div>

				<!-- debt limit -->
				<div class="mt-5" v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'debt_limit', 'update'))">
					<label for class="vs-input--label">{{ $t("Limit") }}:</label>
					<vx-input-group prependClasses="border border-solid border-grey border-r-0">
						<template slot="prepend">
							<div class="prepend-text text-black">
								<span>VNĐ</span>
							</div>
						</template>
						<cbs-masked-input
							dataType="int"
							class="vs-inputx vs-input--input normal w-full"
							v-model.number="debtLimit"
							name="debtLimit"
							:userSetting="userSettings"
							v-validate="{ min_value: 0 }"
							:data-vv-as="$t('Limit')"
							:placeholder="`${$t('Actions.InputMoney')}`"
						/>
					</vx-input-group>
					<span class="text-danger text-sm break-normal" v-show="errors.has('debtLimit')">{{ errors.first("debtLimit") }}</span>
				</div>
				<!-- PHONE -->
				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'phone', 'update'))">
					<label for class="vs-input--label block mt-5"> {{ $t("Phone") }}: </label>
					<vs-input
						:data-vv-as="$t('Phone')"
						:placeholder="`${$t('Actions.Input')} ${$t('Phone')}`"
						v-model="dataPhone"
						class="w-full"
						name="phone"
						v-validate="{ regex: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/ }"
					/>
					<span class="text-danger text-sm" v-show="errors.has('phone')">{{ errors.first("phone") }}</span>
				</div>

				<!-- EMAIL -->
				<div class="my-5" v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'email', 'update'))">
					<label for class="vs-input--label"> {{ $t("Email") }}: </label>
					<vs-input
						v-model="dataEmail"
						type="email"
						class="w-full"
						name="email"
						:data-vv-as="$t('Email')"
						:placeholder="`${$t('Actions.Input')} ${$t('Email')}`"
						v-validate="{ email: true }"
					/>
					<span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span>
				</div>


				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'phone', 'update'))">
					<label for class="vs-input--label block mt-5"> Ngày sinh: </label>
					<cbs-date-picker
						clearable
						class="w-full"
						type="date"
						name="dataDob"
						prefix-icon="''"
						ref="dataDobRef"
						format="DD-MM-yyyy"
						value-format="yyyy-MM-dd HH:mm:ss"
						:data-vv-as="'Ngày sinh'"
						:placeholder="'Chọn Ngày sinh'"
						v-model="dataDob"
					/>
					<span class="text-danger text-sm" v-show="errors.has('dataDob')">{{ errors.first("dataDob") }}</span>
				</div>

				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'phone', 'update'))">
					<label for class="vs-input--label block mt-5"> Giới tính: </label>
					<v-select
						:clearable="false"
						class="border-none w-full"
						:placeholder="`${$t('Actions.Input')} Giới tính`"
						v-model="dataGender"
						name="dataGender"
						:options="[{id: 1, name: 'Nam'}, {id: 0, name: 'Nữ'}]"
						:reduce="district => district.id"
						label="name"
						:data-vv-as="'Giới tính'"
					>
						<template #no-options>
							Chọn giới tính
						</template>
					</v-select>
					<span class="text-danger text-sm" v-show="errors.has('dataGender')">{{ errors.first("dataGender") }}</span>
				</div>

				<!-- City and District -->
				<div class="grid grid-cols-2 mt-5">
					<div class="mb-5 pr-4">
						<label for class="text-base vs-input--label"> {{ $t("City") }}: </label>
						<v-select
							:clearable="false"
							class="border-none w-full"
							:placeholder="`${$t('Actions.Input')} ${$t('City')}`"
							v-model="city"
							name="city"
							:options="$store.state.states"
							:reduce="states => states.id"
							label="name"
							:data-vv-as="$t('City')"
						/>
						<span class="text-danger text-sm break-normal" v-show="errors.has('city')">{{ errors.first("city") }}</span>
					</div>
					<div class="mb-5">
						<label for class="text-base vs-input--label"> {{ $t("District") }}: </label>

						<v-select
							:clearable="false"
							class="border-none w-full"
							:placeholder="`${$t('Actions.Input')} ${$t('District')}`"
							v-model="district"
							name="district"
							:options="$store.state.districts"
							:reduce="district => district.id"
							label="name"
							:data-vv-as="$t('District')"
						>
							<template #no-options>
								Chọn tỉnh/thành phố trước
							</template>
						</v-select>
						<span class="text-danger text-sm break-normal" v-show="errors.has('district')">{{ errors.first("district") }}</span>
					</div>
				</div>
				<!-- Ward and street -->
				<div class="grid grid-cols-2">
					<div class="mb-5 pr-4">
						<label for class="text-base vs-input--label"> {{ $t("Ward") }}: </label>

						<v-select
							:clearable="false"
							class="border-none w-full"
							:placeholder="`${$t('Actions.Input')} ${$t('Ward')}`"
							v-model="ward"
							name="ward"
							:options="$store.state.wards"
							:reduce="ward => ward.id"
							label="name"
							:data-vv-as="$t('Ward')"
						>
							<template #no-options>
								Chọn quận/huyện trước
							</template>
						</v-select>
						<span class="text-danger text-sm break-normal" v-show="errors.has('ward')">{{ errors.first("ward") }}</span>
					</div>
					<div class="mb-5">
						<label for class="text-base vs-input--label"> {{ $t("Street") }}: </label>
						<cbs-input v-model="street" class="w-full" name="street" :data-vv-as="$t('Street')" :placeholder="`${$t('Actions.Input')} ${$t('Street')}`" />
						<span class="text-danger text-sm break-normal" v-show="errors.has('street')">{{ errors.first("street") }}</span>
					</div>
				</div>

				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'phone', 'update'))">
					<label for class="vs-input--label block mt-5"> CMND/CCCD: </label>
					<vs-input
						:data-vv-as="'dataCMND'"
						:placeholder="`${$t('Actions.Input')} CMND/CCCD`"
						v-model="dataCMND"
						class="w-full"
						name="dataCMND"
					/>
					<span class="text-danger text-sm" v-show="errors.has('dataCMND')">{{ errors.first("dataCMND") }}</span>
				</div>

				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'phone', 'update'))">
					<label for class="vs-input--label block mt-5"> Ngày cấp: </label>
					<cbs-date-picker
						clearable
						class="w-full"
						type="date"
						name="dataCMNDNgayCap"
						prefix-icon="''"
						ref="dataCMNDNgayCapRef"
						format="DD-MM-yyyy"
						value-format="yyyy-MM-dd HH:mm:ss"
						:data-vv-as="'Ngày cấp'"
						:placeholder="'Chọn Ngày cấp'"
						v-model="dataCMNDNgayCap"
					/>
					<span class="text-danger text-sm" v-show="errors.has('dataCMNDNgayCap')">{{ errors.first("dataCMNDNgayCap") }}</span>
				</div>

				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'phone', 'update'))">
					<label for class="vs-input--label block mt-5"> Nơi cấp: </label>
					<vs-input
						:data-vv-as="$t('Phone')"
						:placeholder="`${$t('Actions.Input')} Nơi cấp`"
						v-model="dataCMNDNoiCap"
						class="w-full"
						name="dataCMNDNoiCap"
					/>
					<span class="text-danger text-sm" v-show="errors.has('dataCMNDNoiCap')">{{ errors.first("dataCMNDNoiCap") }}</span>
				</div>

				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'cmnd', 'update'))">
					<label for class="vs-input--label block mt-5"> Passport: </label>
					<vs-input
						:data-vv-as="'passport_no'"
						:placeholder="`${$t('Actions.Input')} Passport`"
						v-model="passport_no"
						class="w-full"
						name="passport_no"
					/>
					<span class="text-danger text-sm" v-show="errors.has('passport_no')">{{ errors.first("passport_no") }}</span>
				</div>

				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'passport_ngay_cap', 'update'))">
					<label for class="vs-input--label block mt-5"> Ngày cấp: </label>
					<cbs-date-picker
						clearable
						class="w-full"
						type="date"
						name="passport_ngay_cap"
						prefix-icon="''"
						ref="passport_ngay_capRef"
						format="DD-MM-yyyy"
						value-format="yyyy-MM-dd HH:mm:ss"
						:data-vv-as="'Ngày cấp'"
						:placeholder="'Chọn Ngày cấp'"
						v-model="passport_ngay_cap"
					/>
					<span class="text-danger text-sm" v-show="errors.has('passport_ngay_cap')">{{ errors.first("passport_ngay_cap") }}</span>
				</div>

				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'cmnd', 'update'))">
					<label for class="vs-input--label block mt-5"> Nơi cấp: </label>
					<vs-input
						:data-vv-as="'passport_noi_cap'"
						:placeholder="`${$t('Actions.Input')} Nơi cấp`"
						v-model="passport_noi_cap"
						class="w-full"
						name="passport_noi_cap"
					/>
					<span class="text-danger text-sm" v-show="errors.has('passport_noi_cap')">{{ errors.first("passport_noi_cap") }}</span>
				</div>

				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'cmnd', 'update'))">
					<label for class="vs-input--label block mt-5"> Thời hạn đến: </label>
					<cbs-date-picker
						clearable
						class="w-full"
						type="date"
						name="passport_han_den"
						prefix-icon="''"
						ref="passport_han_denRef"
						format="DD-MM-yyyy"
						value-format="yyyy-MM-dd HH:mm:ss"
						:data-vv-as="'Thời hạn đến'"
						:placeholder="'Chọn Thời hạn đến'"
						v-model="passport_han_den"
					/>
					<span class="text-danger text-sm" v-show="errors.has('passport_han_den')">{{ errors.first("passport_han_den") }}</span>
				</div>

				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'cmnd', 'update'))">
					<label for class="vs-input--label block mt-5"> Họ tên thân nhân: </label>
					<vs-input
						:data-vv-as="'than_nhan'"
						:placeholder="`${$t('Actions.Input')} Họ tên thân nhân`"
						v-model="than_nhan"
						class="w-full"
						name="than_nhan"
					/>
					<span class="text-danger text-sm" v-show="errors.has('than_nhan')">{{ errors.first("than_nhan") }}</span>
				</div>

				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'cmnd', 'update'))">
					<label for class="vs-input--label block mt-5"> Quan hệ: </label>
					<vs-input
						:data-vv-as="'than_nhan_qh'"
						:placeholder="`${$t('Actions.Input')} Quan hệ`"
						v-model="than_nhan_qh"
						class="w-full"
						name="than_nhan_qh"
					/>
					<span class="text-danger text-sm" v-show="errors.has('than_nhan_qh')">{{ errors.first("than_nhan_qh") }}</span>
				</div>

				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'cmnd', 'update'))">
					<label for class="vs-input--label block mt-5"> Điện thoại thân nhân: </label>
					<vs-input
						:data-vv-as="'than_nhan_sdt'"
						:placeholder="`${$t('Actions.Input')} Điện thoại thân nhân`"
						v-model="than_nhan_sdt"
						class="w-full"
						name="than_nhan_sdt"
					/>
					<span class="text-danger text-sm" v-show="errors.has('than_nhan_sdt')">{{ errors.first("than_nhan_sdt") }}</span>
				</div>

				<div v-if="!dataId || (dataId && getCustomerDecentralizedAccess(data.c_permissions, 'cmnd', 'update'))">
					<label for class="vs-input--label block mt-5"> Email thân nhân: </label>
					<vs-input
						:data-vv-as="'than_nhan_email'"
						:placeholder="`${$t('Actions.Input')} Email thân nhân`"
						v-model="than_nhan_email"
						class="w-full"
						name="than_nhan_email"
					/>
					<span class="text-danger text-sm" v-show="errors.has('than_nhan_email')">{{ errors.first("than_nhan_email") }}</span>
				</div>

				<div v-if="getCustomerDecentralizedAccess(data.c_permissions, 'tags', 'update')">
					<CbsTags v-model="tags" />
				</div>

				<!-- DOB -->
				<!-- <div class="birthDate my-5">
					<label for class="vs-input--label">{{ $t("DOB") }}:</label>
					<vx-input-group>
						<template slot="append">
							<div class="append-text text-black">
								<i class="nucleo nucleo-calendar-date" @click="triggerClickDatetimePicker"></i>
							</div>
						</template>

						<cbs-date-picker
							clearable
							class="w-full"
							prefix-icon="''"
							ref="dateTimePickerRef"
							:format="userDateFormat"
							value-format="yyyy-MM-dd"
							:placeholder="`${$t('Actions.Choose')} ${$t('DOB').toLowerCase()}`"
							v-model="birthDate"
						/>
					</vx-input-group>
				</div> -->
			</div>
		</PerfectScrollbar>

		<div class="flex justify-center flex-wrap items-center" slot="footer">
			<vs-button :type="dataId ? 'filled' : 'border'" :class="['w-full sm:w-1/3 sm:mr-6 font-bold', { 'mb-3 sm:mb-0': !dataId }]" @click.stop="submitData(!!dataId)">
				{{ dataId ? $t("Actions.Save") : $t("Actions.SaveAndRecreate") }}
			</vs-button>
			<vs-button v-show="!dataId" class="w-full sm:w-1/3 font-bold" @click.stop="submitData(true)">{{ $t("Actions.Save") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import vSelect from "vue-select";
import * as _ from "lodash";
import CbsTags from "@/components/cbs-tags/CbsTags";

export default {
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	watch: {
		isSidebarActive(val) {
			if (!val) return;
			if (Object.entries(this.data).length === 0) {
				this.initValues();
			} else {
				let { id, name, code, email, dob, phone, group, ward_id, district_id, state_id, street, debt_limit, tags, gender, cmnd, cmnd_ngay_cap, cmnd_noi_cap,
					passport_no, passport_ngay_cap, passport_noi_cap, passport_han_den, than_nhan, than_nhan_qh, than_nhan_sdt, than_nhan_email
				} = this.data;
				this.dataId = id;
				this.dataCode = code;
				this.dataName = name;
				this.dataEmail = email;
				this.dataPhone = phone;
				this.birthDate = dob || null;
				this.city = state_id;
				this.district = district_id;
				this.ward = ward_id;
				this.street = street;
				this.debtLimit = debt_limit;
				this.group = group;
				this.tags = tags;
			
				this.dataDob = dob;
				this.dataGender = gender;
				this.dataCMND = cmnd;
				this.dataCMNDNgayCap = cmnd_ngay_cap;
				this.dataCMNDNoiCap = cmnd_noi_cap

				this.passport_no = passport_no;
				this.passport_ngay_cap = passport_ngay_cap;
				this.passport_noi_cap = passport_noi_cap;
				this.passport_han_den = passport_han_den;
				this.than_nhan = than_nhan;
				this.than_nhan_qh = than_nhan_qh;
				this.than_nhan_sdt = than_nhan_sdt;
				this.than_nhan_email = than_nhan_email;
			}

			this.isFormDirty = false;
			this.initFormData = {
				dataId: this.dataId,
				dataName: this.dataName,
				dataCode: this.dataCode,
				dataEmail: this.dataEmail,
				dataPhone: this.dataPhone,
				birthDate: this.birthDate,
				city: this.city,
				district: this.district,
				ward: this.ward,
				street: this.street,
				debtLimit: this.debtLimit,
				group: this.group,
				tags: this.tags,
				dataDob: this.dataDob,
				dataGender: this.dataGender,
				dataCMND: this.dataCMND,
				dataCMNDNgayCap: this.dataCMNDNgayCap,
				dataCMNDNoiCap: this.dataCMNDNoiCap,
				
				passport_no: this.passport_no,
				passport_ngay_cap: this.passport_ngay_cap,
				passport_noi_cap: this.passport_noi_cap,
				passport_han_den: this.passport_han_den,
				than_nhan: this.than_nhan,
				than_nhan_qh: this.than_nhan_qh,
				than_nhan_sdt: this.than_nhan_sdt,
				than_nhan_email: this.than_nhan_email,
			};
		},
		computedFormData: {
			handler: function(newVal) {
				this.isFormDirty = JSON.stringify(newVal) !== JSON.stringify(this.initFormData) && newVal.dataId === this.initFormData.dataId;
			},
			deep: true
		},
		async city() {
			if (this.city) {
				await this.$store.dispatch("fetchDistricts", {
					state_id: this.city
				});
				const isDistrictValid = _.findIndex(this.$store.state.districts, { id: this.district });
				if (isDistrictValid === -1) {
					this.district = null;
				}
			}
		},
		async district() {
			if (this.district) {
				await this.$store.dispatch("fetchWards", {
					district_id: this.district
				});
				const isWardValid = _.findIndex(this.$store.state.wards, { id: this.ward });
				if (isWardValid === -1) {
					this.ward = null;
				}
			} else {
				this.$store.commit("UPDATE_WARDS", []);
				this.ward = null;
			}
		}
	},
	data() {
		return {
			passport_no: null,//passport_no,
			passport_ngay_cap: null,//passport_ngay_cap,
			passport_noi_cap: null,//passport_noi_cap,
			passport_han_den: null,//passport_han_den,
			than_nhan: null,//than_nhan,
			than_nhan_qh: null,//than_nhan_qh,
			than_nhan_sdt: null,//than_nhan_sdt,
			than_nhan_email: null,//than_nhan_email,
			dataDob: null,
			dataGender: null,
			dataCMND: null,
			dataCMNDNgayCap: null,
			dataCMNDNoiCap: null,
			dataId: null,
			dataName: "",
			dataCode: "",
			dataEmail: "",
			dataPhone: "",
			birthDate: null,
			city: null,
			district: null,
			ward: null,
			street: null,
			debtLimit: "",
			group: "",
			tags: [],
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			initFormData: {},
			isFormDirty: false
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		computedFormData() {
			return {
				dataId: this.dataId,
				dataName: this.dataName,
				dataCode: this.dataCode,
				dataEmail: this.dataEmail,
				dataPhone: this.dataPhone,
				birthDate: this.birthDate,
				city: this.city,
				district: this.district,
				ward: this.ward,
				street: this.street,
				debtLimit: this.debtLimit,
				group: this.group,
				tags: this.tags,

				dataDob: this.dataDob,
				dataGender: this.dataGender,
				dataCMND: this.dataCMND,
				dataCMNDNgayCap: this.dataCMNDNgayCap,
				dataCMNDNoiCap: this.dataCMNDNoiCap,

				passport_no: this.passport_no,
				passport_ngay_cap: this.passport_ngay_cap,
				passport_noi_cap: this.passport_noi_cap,
				passport_han_den: this.passport_han_den,
				than_nhan: this.than_nhan,
				than_nhan_qh: this.than_nhan_qh,
				than_nhan_sdt: this.than_nhan_sdt,
				than_nhan_email: this.than_nhan_email,
			};
		}
	},
	methods: {
		initValues() {
			if (this.data.id) return;
			this.dataId = null;
			this.dataName = "";
			this.dataCode = "";
			this.dataPhone = "";
			this.dataEmail = "";
			this.birthDate = null;
			this.city = null;
			this.district = null;
			this.ward = null;
			this.street = null;
			this.debtLimit = "";
			this.group = "";
			this.tags = [];
			
			this.dataDob = null;
			this.dataGender = null;
			this.dataCMND = null;
			this.dataCMNDNgayCap = null;
			this.dataCMNDNoiCap = null;

			this.passport_no = null;//passport_no;
			this.passport_ngay_cap = null;//passport_ngay_cap;
			this.passport_noi_cap = null;//passport_noi_cap;
			this.passport_han_den = null;//passport_han_den;
			this.than_nhan = null;//than_nhan;
			this.than_nhan_qh = null;//than_nhan_qh;
			this.than_nhan_sdt = null;//than_nhan_sdt;
			this.than_nhan_email = null;//than_nhan_email;

			this.$validator.reset();
		},
		handleCreateOrUpdateSuccess(isCloseForm) {
			if (isCloseForm) {
				this.$emit("closeSidebar");
			}
			this.initValues();
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: this.$t(`${this.dataId ? "UpdateCustomerSuccessful" : "CreateCustomerSuccessful"}`)
				}
			});
		},
		async handleCreateOrUpdateCustomer(dataObj, isCloseForm) {
			try {
				this.$vs.loading();
				if (this.dataId) {
					await this.$store.dispatch("customerManagement/updateCustomer", {
						...dataObj,
						id: this.dataId
					});
				} else {
					await this.$store.dispatch("customerManagement/addCustomer", dataObj);
				}

				this.handleCreateOrUpdateSuccess(isCloseForm);
			} catch (error) {
				console.error("ERR", error);
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData(isCloseForm = false) {
			this.$validator.validateAll().then(result => {
				if (result) {
					const dataObj = {
						name: this.dataName,
						code: this.dataCode || "",
						email: this.dataEmail || "",
						phone: this.dataPhone || "",
						dob: this.birthDate || null,
						state_id: this.city,
						district_id: this.district,
						ward_id: this.ward,
						street: this.street,
						debt_limit: this.debtLimit,
						group: this.group,
						tag_ids: this.tags,

						dob: this.dataDob,
						gender: this.dataGender,
						cmnd: this.dataCMND,
						cmnd_ngay_cap: this.dataCMNDNgayCap,
						cmnd_noi_cap: this.dataCMNDNoiCap,
						passport_no: this.passport_no,
						
						passport_ngay_cap: this.passport_ngay_cap,
						passport_noi_cap: this.passport_noi_cap,
						passport_han_den: this.passport_han_den,
						than_nhan: this.than_nhan,
						than_nhan_qh: this.than_nhan_qh,
						than_nhan_sdt: this.than_nhan_sdt,
						than_nhan_email: this.than_nhan_email,
					};

					this.handleCreateOrUpdateCustomer(dataObj, isCloseForm);
				}
			});
		},

		triggerClickDatetimePicker() {
			this.$refs.dateTimePickerRef.$children[0].pickerVisible = true;
		}
	},
	components: {
		vSelect,
		CbsTags
	},
	created() {
		this.$store.dispatch("fetchStates");
	}
};
</script>
